"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonLoadingStyles = void 0;
const getButtonLoadingStyles = isLoading => ({
  // fade in content after done loading data
  transition: "opacity 0.3s",
  opacity: isLoading ? 0 : 1
});
exports.getButtonLoadingStyles = getButtonLoadingStyles;
//# sourceMappingURL=getButtonLoadingStyles.js.map